import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import CsvDownloadButton from  'components/csv_download_button';
import ManagedInput from 'components/form/managed_input';

export default class SurveyCsvExporter extends React.Component {

  static propTypes = {
    surveyPropertyCount: PropTypes.number.isRequired,
    surveyPropertyCsvColumns: PropTypes.object.isRequired,
    surveysPath: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired
  }
  
  state = {
    selectedColumns: Object.keys(this.props.surveyPropertyCsvColumns)
  }

  paramsString = () => {
    return `selected_columns=${this.state.selectedColumns}`;
  }

  updateSelectedColumn = (checked, event) => {
    const key = event.target.name;
    this.setState((state) => {
      let selectedColumns = [...state.selectedColumns];
      if (checked) {
        if (!selectedColumns.includes(key)) selectedColumns.push(key);
      } else {
        if (selectedColumns.includes(key)) selectedColumns = selectedColumns.filter(item => item != key);
      }
      return { selectedColumns };
    });
  }

  renderColumnCheckboxes() {
    return Object.entries(this.props.surveyPropertyCsvColumns).map(([key, value]) => (
      <div key={key} name="columnSelector">
        <ManagedInput
          name={key}
          type="checkbox"
          value={this.state.selectedColumns.includes(key)}
          onValueChange={this.updateSelectedColumn}
        >
          {value}
        </ManagedInput>
      </div>
    ));
  }

  render() {
    return (  
      <div>
        <div className="mb-4">
          <h2 className="h2">
            Export Survey Properties as CSV
          </h2>
          <div className="text-muted">
            {pluralize('potential location', this.props.surveyPropertyCount, true)} to export.
            &nbsp;Only the selected columns will be included in your exported CSV.
          </div>
        </div>
        {this.renderColumnCheckboxes()}
        <div className="pull-right row-eq-height">
          <CsvDownloadButton entityName='surveys' href={`${this.props.surveysPath}.csv?${this.paramsString()}`}/>
          <span className='pull-right btn btn-cancel' onClick={this.props.onCancel}>
            Cancel
          </span>
        </div>
      </div>
    );
  }
}
